import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`A CSS selector that identifies the container where the `}<inlineCode parentName="p">{`CvvInput`}</inlineCode>{` will be appended. If the `}<inlineCode parentName="p">{`container`}</inlineCode>{` is not found and the `}<inlineCode parentName="p">{`CVVInput`}</inlineCode>{` cannot be mounted, the Promise returned by `}<inlineCode parentName="p">{`createCVVInput`}</inlineCode>{` is resolved with `}<inlineCode parentName="p">{`null`}</inlineCode>{` and an error message is logged to the developer's console.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      